import { TranslationsMap } from '../translations.map';

export const esLocale: TranslationsMap = {
  // Common
  account_header: 'Cuenta',
  overview: 'Resumen',
  profile: 'Perfil',
  sign_out: 'Cerrar sesión',
  save: 'Guardar',
  days: 'Días',
  weeks: 'Semanas',
  cancel: 'Cancelar',
  save_changes: 'Guardar cambios',
  general_information: 'Información general',
  enabled: 'Habilitado',
  disabled: 'Deshabilitado',
  confirm: 'Confirmar',
  error: 'Error',
  learn_more: 'Más información',
  about: 'Acerca de',

  // Overview
  welcome_user: '¡Bienvenido, {{name}}!',
  organization_header: 'Organizaciones',
  organizational_units_header: 'Unidades organizacionales',
  studies_header: 'Estudios',
  data_sources_header: 'Fuentes de datos',
  admins_header: 'Administradores',
  first_name_header: 'Nombre',
  last_name_header: 'Apellido',
  role_header: 'Roles',
  participants_header: 'Participantes',
  name_header: 'Nombre',
  display_name_header: 'Nombre visible',
  created_header: 'Creado',
  joined_header: 'Unido',
  researchers_header: 'Investigadores',
  email_header: 'Correo electrónico',
  phone_number_header: 'Número de teléfono',

  admin: 'Administrador',
  researcher: 'Investigador',
  users: 'Usuarios',
  manager: 'Gerente',

  study: 'Estudio',
  data_source: 'Fuente de datos',

  error_loading_overview: 'Error al obtener el resumen',
  error_getting_organization: 'Error al obtener la organización',
  error_getting_study: 'Error al obtener el estudio',

  num_participants: 'participantes',
  num_researchers: 'investigadores',
  num_studies: 'estudios',
  num_organizational_units: 'unidades organizacionales',
  num_data_sources: 'fuentes de datos',

  organization_name: 'Nombre de la organización',
  edit_organization: 'Editar organización',
  actions: 'Acciones',
  create_study: 'Crear estudio',
  creation_date: 'Fecha de creación',
  organization_overview: 'Resumen de la organización',
  organization_updated_successfully: '{{name}} actualizado con éxito 🎉',

  success_invitation_code_refreshed: 'El código de invitación se actualizó con éxito 🎉',
  success_invitation_code_copied: 'El código de invitación se copió al portapapeles',
  copy_invitation_code: 'Copiar código de invitación',
  refresh_invitation_code: 'Actualizar código de invitación',
  edit_study: 'Editar estudio',

  invite_researcher: 'Invitar a un investigador',
  researcher_invited_successfully: 'Investigador invitado con éxito',
  invite: 'Invitar',

  example_num: 'Ej. 10',
  study_updated_successfully: '{{name}} actualizado con éxito 🎉',
  study_name: 'Nombre del estudio',
  description: 'Descripción',
  expected_total_participants: 'Total de participantes esperado',
  expected_time_in_study: 'Tiempo esperado en el estudio',
  expected_participant_duration_in_study: 'Duración esperada por participante en el estudio',
  start_date: 'Fecha de inicio',
  completion_date: 'Fecha de finalización',
  no_participants_in_study: 'Ningún participante se ha unido a este estudio',

  create_study_for: 'Crear estudio para {{name}}',
  expected_participants: 'Participantes esperados',
  enter_study_description: 'Introduzca la descripción del estudio',

  edit_data_source: 'Editar fuente de datos',
  delete_data_source: 'Eliminar fuente de datos',
  no_description_provided: 'No se proporcionó descripción',

  no_researchers_assigned_to_this_study: 'No se han asignado investigadores a este estudio.',
  no_researchers_assigned_to_this_data_source:
    'No se han asignado investigadores a esta fuente de datos.',

  unassign_researcher: 'Desasignar investigador',
  unassign_researcher_from_data_source_confirmation:
    '¿Está seguro de que desea desasignar a este investigador de la fuente de datos {{name}} (ID: {{id}})?',
  unassign_researcher_from_study_confirmation:
    '¿Está seguro de que desea desasignar a este investigador del estudio {{name}} (ID: {{id}})?',
  user_assigned_to_entity: 'Usuario asignado a {{entityName}}',
  assign_researcher: 'Asignar investigador',
  assign_researcher_confirmation:
    'Asignar este usuario al {{selectedEntityType}} dará acceso a todos los datos y funciones de {{selectedEntityType}}. ¿Está seguro de que desea continuar?',
  assign_to_study_or_data_source: 'Asignar al estudio o fuente de datos',

  find_entities: 'Buscar entidades',
  no_studies_found: 'No se encontraron estudios',
  no_data_sources_found: 'No se encontraron fuentes de datos',

  organization_wide_access: 'Acceso a toda la organización',
  confirm_modifying_organization_wide_access:
    'Confirmar la modificación del acceso a toda la organización',
  disable_organization_wide_access_confirmation:
    '¿Está seguro de que desea desactivar el acceso a toda la organización? Esto revocará el acceso de todos los investigadores a todos los estudios y fuentes de datos en la organización. Los investigadores solo podrán acceder a los estudios y fuentes de datos a los que hayan sido asignados explícitamente.',
  enable_organization_wide_access_confirmation:
    '¿Está seguro de que desea habilitar el acceso a toda la organización? Esto otorgará a todos los investigadores acceso a todos los estudios y fuentes de datos en la organización.',
  note_change_not_saved_until_click_save:
    'Nota: este cambio no se guardará hasta que haga clic en el botón de guardar.',

  no_organizational_units_created:
    'No se han creado unidades organizacionales para esta organización',
  no_researchers_created: 'No se han creado investigadores para esta organización',
  no_data_sources_created: 'No se han creado fuentes de datos para esta organización',
  no_studies_created: 'No se han creado estudios para esta organización',
  error_fetching_organizations: 'Hubo un error al obtener sus organizaciones',

  no_org_assigned: 'Aún no se le ha asignado a ninguna organización',
  request_admin_to_join_org: 'Para unirse a una organización, solicite acceso a su administrador',
  contact_administrator: 'Contactar al administrador',

  // Profile
  my_profile: 'Mi perfil',
  profile_info: 'Información del perfil',
  change_password: 'Cambiar contraseña',

  new_passwords_dont_match: 'La nueva contraseña y la confirmación deben coincidir',
  success_password_reseted: 'La contraseña se restableció con éxito 🎉',
  old_password: 'Contraseña anterior',
  new_password: 'Nueva contraseña',
  confirm_password: 'Confirmar contraseña',

  success_profile_updated: 'Actualización del perfil exitosa 🎉',
  email_phone_verified: 'Su {{attribute}} fue verificado con éxito 🎉',
  email: 'correo electrónico',
  phone_number: 'número de teléfono',
  verification_sent: 'Se ha enviado un código de verificación a su {{attribute}}',
  basic_information: 'Información básica',
  information_only_visible_to_you: 'Esta información solo es visible para usted',
  error_loading_profile: 'Error al cargar el perfil',
  error_editing_profile: 'Error al editar el perfil',
  last_updated: 'Última actualización',
  user_roles: 'Roles de usuario',
  edit: 'Editar',
  verify_your: 'Verifique su {{attribute}}',

  verify_header: 'Verificar',
  please_enter_verification_sent: 'Ingrese el código de verificación enviado a su {{attribute}}',

  enter_verification_code: 'Introduzca el código de verificación',
  resend_verification_code: 'Reenviar código de verificación',

  // Not found
  oops_page_not_found: '¡Vaya! Página no encontrada.',
  could_not_find_page: 'No pudimos encontrar la página que está buscando.',
  back_to_home_page: 'Volver a la página de inicio',

  // Create Cohort Builder
  create_cohort_builder: 'Crear un generador de cohortes',
  create_cohort: 'Crear una cohorte',
  no_cohorts_created: 'No se han creado cohortes',
  no_cohorts_created_description:
    'Las cohortes le ayudan a definir y gestionar subconjuntos de sus datos para análisis dirigidos. Cree su primera cohorte para comenzar.',

  // Dataset
  data: 'Datos',

  // Dataset Overview
  time_span: 'Rango de tiempo',
  record_count: 'Número de registros',
  data_provider: 'Proveedor de datos',
  data_dictionary: 'Diccionario de datos',
  completeness_score: 'Puntuación de completitud',
  column_name: 'Nombre de la columna',
  data_dictionary_description: 'Diccionario de datos',
  column_type: 'Tipo de datos',
  column_description: 'Descripción de la columna',
  column_completeness_score: 'Puntuación de completitud de la columna',
  select_table: 'Seleccionar tabla',
  search_column_name_type_description: 'Buscar por nombre de columna, tipo o descripción',

  // Dataset Cohort
  cohort: 'Cohorte',
  search_cohort: 'Buscar por nombre',
  action_create_cohort: 'Crear cohorte',
  cohort_column_name_header: 'Nombre de la columna',
  cohort_column_owner_header: 'Propietario',
  cohort_column_description_header: 'Descripción',
  cohort_column_patient_count_header: 'Pacientes',

  // Dataset Codes
  no_codes_created: 'No code sets created yet',
  no_codes_created_description:
    'Code sets help you organize and manage reusable groups of codes for your analytics. Create a new code set in Analytics to get started.',

  // Complete Account Creation
  create_your_account: 'Crea tu cuenta',
  complete_your_account_details:
    'Completa los detalles de tu cuenta para empezar a explorar Medeloop',
  enter_given_name: 'Ingresa tu nombre',
  enter_family_name: 'Ingresa tu apellido',
  enter_phone_number: 'Ingresa tu número de teléfono',
  to_change_use_sso_provider: 'Para cambiar {{field}}, usa tu proveedor SSO',
  given_name: 'Nombre',
  family_name: 'Apellido',
  continue: 'Continuar',
  something_wrong_authentication: 'Ocurrió un error con la autenticación',
  something_went_wrong: 'Ocurrió un error',
  code_inserted_wrong: 'El código insertado es incorrecto',
  enter_code_to_destination: 'Ingrese el código que fue enviado por SMS a: {{destination}}',
};
